import { cn } from "@repo/shad/lib/utils"
import type { ComponentProps } from "react"

const html = String.raw

const noisePattern = `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  html`
    <svg xmlns="http://www.w3.org/2000/svg" width="250" height="250" viewBox="0 0 100 100">
      <filter id="n">
        <feTurbulence
          type="turbulence"
          baseFrequency="1.4"
          numOctaves="1"
          seed="2"
          stitchTiles="stitch"
          result="n"
        />
        <feComponentTransfer result="g">
          <feFuncR type="linear" slope="4" intercept="1" />
          <feFuncG type="linear" slope="4" intercept="1" />
          <feFuncB type="linear" slope="4" intercept="1" />
        </feComponentTransfer>
        <feColorMatrix type="saturate" values="0" in="g" />
      </filter>
      <rect width="100%" height="100%" filter="url(#n)" />
    </svg>
  `.replace(/\s+/g, " "),
)}")`

export function Wallpaper({
  children,
  color,
  className,
  innerClassName,
  ...props
}: {
  color: "green" | "blue" | "purple" | "brown" | "mist"
  dark?: boolean
  innerClassName?: string
} & ComponentProps<"div">) {
  const gradientByColor = {
    blue: `dark:from-[#243a42] dark:to-[#232f40] from-[#637c86] to-[#778599]`,
    brown: "dark:from-[#382d23] dark:to-[#3d2323] from-[#8d7359] to-[#765959]",
    green: "dark:from-[#333a2b] dark:to-[#26361b] from-[#9ca88f] to-[#596352]",
    mist: "dark:from-[#2a2e35] dark:to-[#1f2328] from-[#7a8291] to-[#6b7280]",
    purple: "dark:from-[#412c42] dark:to-[#3c1a26] from-[#7b627d] to-[#8f6976]",
  } satisfies Record<"green" | "blue" | "purple" | "brown" | "mist", string>

  return (
    <div
      data-color={color}
      className={cn("relative overflow-hidden bg-linear-to-b", gradientByColor[color], className)}
      {...props}
    >
      <div
        className={cn("absolute inset-0 mix-blend-overlay opacity-30 dark:opacity-25")}
        style={{
          backgroundPosition: "center",
          backgroundImage: noisePattern,
        }}
      />
      <div className={cn("relative", innerClassName)}>{children}</div>
    </div>
  )
}

export function WallpaperColorSwitch({
  children,
  className,
  ...props
}: {} & ComponentProps<"div">) {
  return (
    <div
      className={cn("relative", className)}
      style={{
        backgroundColor: "var(--sidebar)",
        backgroundImage: `linear-gradient(
          to bottom,
          color-mix(in oklab, var(--sidebar) 100%, white),
          color-mix(in oklab, var(--sidebar) 95%, black)
        )`,
      }}
      {...props}
    >
      <div
        className={cn("absolute inset-0 opacity-100 dark:opacity-10")}
        style={{
          backgroundPosition: "center",
          backgroundRepeat: "repeat",
          backgroundSize: "180px 180px",
          backgroundImage: noisePattern,
        }}
      />
      <div className="relative">{children}</div>
    </div>
  )
}
